import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const noOfDeletedSurveyAction = createAsyncThunk(
    'menu-delete-survey',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/support-server/api/delete-survey?s_date=${data?.s_date}&e_date=${data?.e_date}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const noOfDeletedSurveySlice = createSlice({
    name: 'menu-delete-survey',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(noOfDeletedSurveyAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(noOfDeletedSurveyAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(noOfDeletedSurveyAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const noOfDeletedSurveyReducer = noOfDeletedSurveySlice.reducer